import { render, staticRenderFns } from "./CaasQueueTable.vue?vue&type=template&id=87d2c39a&scoped=true&"
import script from "./CaasQueueTable.vue?vue&type=script&lang=js&"
export * from "./CaasQueueTable.vue?vue&type=script&lang=js&"
import style0 from "./CaasQueueTable.vue?vue&type=style&index=0&id=87d2c39a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d2c39a",
  null
  
)

export default component.exports